import React from 'react'
import { Button, Tag } from 'antd'
import type { Organization } from '../../types'
import { canAddUsersToOrganization, organizationHasPaidSeatLimit, organizationSeatUsage, organizationSeatUsageLabel } from '../../utils'
import OrgAvatar from '../shared/OrgAvatar'
import PlanUpgradeHint from '../shared/PlanUpgradeHint'

interface MemberGroupHeaderProps {
  org: Organization
  memberCount: number
  currentCustomerId?: string | null
  onInvite: (organization: Organization) => void
  onUpgrade?: (organization: Organization) => void
}

const MemberGroupHeader: React.FC<MemberGroupHeaderProps> = ({
  org,
  memberCount,
  currentCustomerId,
  onInvite,
  onUpgrade,
}) => {
  const canInvite = canAddUsersToOrganization(org)
  const seatLabel = organizationHasPaidSeatLimit(org) ? organizationSeatUsageLabel(org) : null
  const seatsFull = organizationHasPaidSeatLimit(org) && !!organizationSeatUsage(org)?.full
  const inviteButton = (
    <Button
      type="link"
      className="um-refactor__group-invite"
      disabled={!canInvite}
      onClick={() => canInvite && onInvite(org)}
    >
      Invite to this organization
    </Button>
  )

  return (
    <div className="um-refactor__group-head">
      <div className="um-refactor__group-head-inner">
        <div className="um-refactor__group-head-title">
          <OrgAvatar name={org.name} short={org.short} color={org.color} size="sm" />
          <div className="um-refactor__group-name">{org.name}</div>
        </div>
        <div className="um-refactor__group-head-meta">
          <Tag bordered={false} className="um-refactor__plan-badge">
            {org.plan}
          </Tag>
          <div className="um-refactor__group-count">{memberCount} {memberCount === 1 ? 'member' : 'members'}</div>
          {seatLabel && (
            <Tag
              bordered={false}
              className={`um-refactor__seat-badge${seatsFull ? ' um-refactor__seat-badge--full' : ''}`}
            >
              {seatLabel}
            </Tag>
          )}
        </div>
        {canInvite ? inviteButton : (
          <PlanUpgradeHint
            organization={org}
            currentCustomerId={currentCustomerId}
            onUpgrade={onUpgrade}
          >
            {inviteButton}
          </PlanUpgradeHint>
        )}
      </div>
    </div>
  )
}

export default MemberGroupHeader
